import * as angular from 'angular';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { AppStore } from '~/types/main.types';

import { ChartTypes, InterActions } from '@mode/shared/contract-common';
import { ExplorerActionType } from '../../../actions/chart-designer/explorer.actions';
import { MixableBaseController } from '../../../common/component';
import { isChart } from '../../../lib/chart-helpers';
import { makeVizViewerObservables } from '../../../observables/viz-viewer.observables';
import { ChartExplorerService } from '../../../services/chart-designer/chart-explorer.service';
import { FlamingoService } from '../../../services/flamingo-service';
import { ReportApiService } from '../../../services/report-api-service';
import { VizViewerObservables } from '../../../types/viz-designer.types';

class VizViewerController extends MixableBaseController {
  static $inject = ['$scope', 'ChartExplorerService', 'RxStoreService', 'ReportApiService', 'FlamingoService'];

  observables: VizViewerObservables;
  isChart$: Observable<boolean>;
  isTable$: Observable<boolean>;
  isBigValue$: Observable<boolean>;

  private readOnly: boolean;
  private objectContext = ChartTypes.ObjectType.Visualization;

  constructor(
    private $scope: angular.IScope,
    private explorerService: ChartExplorerService,
    private rxStore: AppStore,
    private reportApiService: ReportApiService,
    flamingoService: FlamingoService // for side effects
  ) {
    super();

    this.readOnly = true;
  }

  $onInit() {
    this.observables = makeVizViewerObservables(this.rxStore);
    this.isChart$ = this.observables.chartType$.pipe(map((type) => isChart(type)));
    this.isTable$ = this.observables.chartType$.pipe(map((type) => type === 'table'));
    this.isBigValue$ = this.observables.chartType$.pipe(map((type) => type === 'bigValue'));

    // Report API Service embed handlers - Update on chart interactions (granularity, etc)
    this.reportApiService
      .makeObservable(this.observables.token$)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(({ action, chartToken }) => {
        if (
          action.type === InterActions.Type.ContextClick &&
          action.item.type === InterActions.ContextItemType.ViewData
        ) {
          const target = action.item.target;
          this.$scope.$evalAsync(() => {
            this.rxStore.dispatch({
              chartToken,
              target,
              type: ExplorerActionType.ViewChartData,
            });
          });
        }
      });
  }
}

export const ID = 'vizViewer';

export const VizViewerComponent: angular.IComponentOptions = {
  template: `
  <div class="report-viz-root">
    <div class="viz-viewer-visualization">
      <div class="designer-container">
        <designer-renderer
          ng-if="(ctrl.isChart$ | async:this) || (ctrl.isTable$ | async:this)"
          read-only="ctrl.readOnly"
          observables="ctrl.observables"
          chart-service="ctrl.explorerService"
          is-view-page="true"
          object-context="ctrl.objectContext"
        ></designer-renderer>
        <big-value-designer-renderer
          ng-if="ctrl.isBigValue$ | async:this"
          read-only="ctrl.readOnly"
          observables="ctrl.observables"
          chart-service="ctrl.explorerService"
          is-view-page="true"
          object-context="ctrl.objectContext"
        ></big-value-designer-renderer>
      </div>
    </div>
  </div>
  `,
  controller: VizViewerController,
  controllerAs: 'ctrl',
};
